import BaseModelAPI from '../BaseModelAPI';

export default class PutAwayCategoryList extends BaseModelAPI {

	static entity = 'putawaycategorylist'
	static entityName = 'putawaycategory';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
